const imgRestrictionsByConcepto = {
  servicio: {
    upload: {
      maxFileCount: 3,
      maxFileSize: 4,
      minWidth: 375,
      minHeight: 390,
    },
    thumbnailUpload: {
      maxFileCount: 1,
      maxFileSize: 4,
      minWidth: 138,
      minHeight: 167,
    },
    crop: {
      minCroppedWidth: 375,
      minCroppedHeight: 390,
      maxCroppedWidth: 1125,
      maxCroppedHeight: 1170,
      aspectRatioNumerator: 375,
      aspectRatioDenominator: 390,
    },
    thumbnailCrop: {
      minCroppedWidth: 138,
      minCroppedHeight: 167,
      maxCroppedWidth: 414,
      maxCroppedHeight: 501,
      aspectRatioNumerator: 138,
      aspectRatioDenominator: 167,
    },
  },
  profesional: {
    upload: {
      maxFileCount: 1,
      maxFileSize: 4,
      minWidth: 102,
      minHeight: 82,
    },
    crop: {
      minCroppedWidth: 102,
      minCroppedHeight: 82,
      maxCroppedWidth: 531,
      maxCroppedHeight: 426,
      aspectRatioNumerator: 102,
      aspectRatioDenominator: 82,
    },
  },
  opcion: {
    upload: {
      maxFileCount: 1,
      maxFileSize: 4,
      minWidth: 25,
      minHeight: 25,
    },
    crop: {
      minCroppedWidth: 25,
      minCroppedHeight: 25,
      maxCroppedWidth: 75,
      maxCroppedHeight: 75,
      aspectRatioNumerator: 1,
      aspectRatioDenominator: 1,
    },
  },
  local: {
    upload: {
      maxFileCount: 1,
      maxFileSize: 4,
      minWidth: 129,
      minHeight: 129,
    },
    crop: {
      minCroppedWidth: 129,
      minCroppedHeight: 129,
      maxCroppedWidth: 387,
      maxCroppedHeight: 387,
      aspectRatioNumerator: 1,
      aspectRatioDenominator: 1,
    },
  },
  localBanner: {
    upload: {
      maxFileCount: 1,
      maxFileSize: 4,
      minWidth: 415,
      minHeight: 201,
    },
    crop: {
      minCroppedWidth: 415,
      minCroppedHeight: 201,
      maxCroppedWidth: 1245,
      maxCroppedHeight: 603,
      aspectRatioNumerator: 415,
      aspectRatioDenominator: 201,
    },
  },  
};

const config = {
  api: {
    baseUrl: process.env.REACT_APP_API_URL,
    key: process.env.REACT_APP_API_KEY,
  },
  imgRestrictionsByConcepto,
};

export default config;
